<template>
  <b-modal id="modal-new-chat-template" hide-footer>
    <template #modal-header>
      <h4>
        {{
          data.id
            ? $t("chat-template.update-template")
            : $t("chat-template.new-template")
        }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row class="justify-content-md-center">
            <b-form-group
              class="col-md-12"
              :label="$t('chat-template.name')"
              label-for="name"
            >
              <ValidationProvider
                :name="$t('chat-template.name')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.name"
                  type="text"
                  :placeholder="$t('chat-template.name-placeholder')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>

            <!-- DESCRIPTION -->
            <b-form-group
              class="col-md-12"
              :label="$t('chat-template.description')"
              label-for="description"
            >
              <b-form-input
                v-model="data.description"
                type="text"
                :placeholder="$t('chat.description-placeholder')"
              >
              </b-form-input>
            </b-form-group>

            <b-form-group
              class="col-md-12"
              :label="$t('chat-template.users')"
              label-for="education"
            >
              <ValidationProvider
                :name="$t('chat-template.users')"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="data.users"
                  :placeholder="$t('chat-template.users-placeholder')"
                  :options="wrappedUsersCollege"
                  label="name"
                  multiple
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                  <template #no-options="{}">
                    {{ $t("app.not-found") }}...
                  </template>
                </v-select>
                <div v-if="errors[0]">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </b-form-group>
          </b-row>
          <hr />
          <b-button
            :disabled="messengerLoading"
            variant="success"
            class="float-right"
            type="submit"
          >
            <span v-if="messengerLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            @click="$bvModal.hide('modal-new-chat-template')"
            class="float-right mr-1"
            variant="outline-danger"
            >{{ $t("app.cancel") }}</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "FormTemplate",
  mounted() {
    core.index();
    this.fetchUserCollege();
  },
  data() {
    return {
      data: {
        id: null,
        name: "",
        description: "",
        users: [],
      },
    };
  },
  methods: {
    ...mapActions({
      fetchUserCollege: "fetchUserCollege",
      createOrUpdateChatTemplate: "createOrUpdateChatTemplate",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.data = {
          id: item.id,
          name: item.name,
          description: item.description,
          users: item.users,
        };
      }
      this.$bvModal.show("modal-new-chat-template");
    },
    async onSubmit() {
      let payload = {
        id: this.data.id,
        name: this.data.name,
        description: this.data.description,
        users: this.data.users.map((user) => user.id),
      };
      const resp = await this.createOrUpdateChatTemplate(payload);
      this.$bvModal.hide("modal-new-chat-template");
      core.showSnackbar(
        "success",
        !this.data.id
          ? this.$t("app.success-create")
          : this.$t("app.success-edit")
      );
      this.$emit("refresh");
      this.reserForm();
    },
    reserForm() {
      this.data = {
        id: null,
        name: "",
        description: "",
        users: [],
      };
    },
  },
  computed: {
    ...mapGetters({
      messengerLoading: "messengerLoading",
      usersCollege: "getUserCollege",
      collageAuthUser: "collageAuthUser",
    }),
    wrappedUsersCollege() {
      return this.usersCollege.map((collegeUser) => ({ ...collegeUser.user }));
    },
  },
};
</script>
